export default {"src":"/_next/static/media/blender.eed352b2.svg","height":219,"width":256,"blurWidth":0,"blurHeight":0};